import { render, staticRenderFns } from "./first-level-category-page.vue?vue&type=template&id=4de9c260"
import script from "./first-level-category-page.vue?vue&type=script&lang=js"
export * from "./first-level-category-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports